var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
var ScreenReaderStatusWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  padding: 0;\n  border: none;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  padding: 0;\n  border: none;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n"])));
var AriaLiveRegion = function (_a) {
    var children = _a.children, _b = _a.delay, delay = _b === void 0 ? 5000 : _b;
    var _c = useState(true), visible = _c[0], setVisible = _c[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            setVisible(false);
        }, delay);
        return function () { return clearTimeout(timer); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (visible && (_jsx(ScreenReaderStatusWrapper, __assign({ role: "alert" }, { children: children }))));
};
export default AriaLiveRegion;
var templateObject_1;
